<div class="call-overlay"
     *ngIf="isVisible"
     [class.minimized]="minimized"
     [class.interacting]="isDragging || isResizing"
     [class.pos-mode]="posSession !== null"
     [ngStyle]="overlayStyle">

  <!-- 8 resize handles (hidden when minimized) -->
  <div *ngIf="!minimized" class="resize-handle resize-n"  (mousedown)="onResizeStart($event, 'n')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-ne" (mousedown)="onResizeStart($event, 'ne')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-e"  (mousedown)="onResizeStart($event, 'e')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-se" (mousedown)="onResizeStart($event, 'se')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-s"  (mousedown)="onResizeStart($event, 's')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-sw" (mousedown)="onResizeStart($event, 'sw')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-w"  (mousedown)="onResizeStart($event, 'w')"></div>
  <div *ngIf="!minimized" class="resize-handle resize-nw" (mousedown)="onResizeStart($event, 'nw')"></div>

  <div class="call-header" (mousedown)="onDragStart($event)">
    <span class="call-status">{{ headerLabel }}</span>
    <button nbButton size="tiny" ghost (click)="toggleMinimized()" title="{{ minimized ? 'Expand' : 'Minimize' }}">
      {{ minimized ? '↑' : '↓' }}
    </button>
  </div>

  <!-- ── Call mode: local + remote camera videos ── -->
  <ng-container *ngIf="posSession === null">
    <div class="videos" *ngIf="!minimized">
      <video #remoteVideo autoplay playsinline class="remote-video"></video>
      <video #localVideo autoplay muted playsinline class="local-video"></video>
    </div>

    <div class="controls" *ngIf="!minimized">
      <button
        nbButton
        size="tiny"
        [status]="(isLocalMuted$ | async) ? 'warning' : 'basic'"
        (click)="callService.toggleMute()">
        {{ (isLocalMuted$ | async) ? 'Unmute' : 'Mute' }}
      </button>

      <button
        nbButton
        size="tiny"
        [status]="(isLocalCameraOff$ | async) ? 'warning' : 'basic'"
        (click)="callService.toggleCamera()">
        {{ (isLocalCameraOff$ | async) ? 'Cam On' : 'Cam Off' }}
      </button>

      <button
        nbButton
        size="tiny"
        [status]="isScreenSharing ? 'primary' : 'basic'"
        (click)="toggleScreenShare()">
        {{ isScreenSharing ? 'Stop Share' : 'Share' }}
      </button>

      <button nbButton size="tiny" status="danger" (click)="callService.endCall()">
        End
      </button>
    </div>
  </ng-container>

  <!-- ── POS remote control mode: App View (WebRTC stream) ── -->
  <ng-container *ngIf="posSession !== null && posDesktopSession === null">
    <div class="videos pos-video-wrapper" *ngIf="!minimized">
      <div class="pos-connecting" *ngIf="!posSession.stream">
        <span>Connecting to POS tablet...</span>
      </div>

      <video
        #posVideo
        autoplay
        playsinline
        class="pos-video"
        tabindex="0"
        style="outline: none; cursor: crosshair;"
        (mousedown)="posVideoRef.nativeElement.focus(); onPosMouseEvent($event)"
        (mouseup)="onPosMouseEvent($event)"
        (mousemove)="onPosMouseEvent($event)"
        (dblclick)="onPosMouseEvent($event)"
        (wheel)="onPosWheelEvent($event)"
        (keydown)="onPosKeyEvent($event)"
        (keyup)="onPosKeyEvent($event)"
        *ngIf="posSession.stream">
      </video>
    </div>

    <div class="controls" *ngIf="!minimized">
      <button nbButton size="tiny" status="danger" (click)="endPosSession()">
        End Control
      </button>
    </div>
  </ng-container>

  <!-- ── Desktop View mode: JPEG frame stream from posproxy agent ── -->
  <ng-container *ngIf="posDesktopSession !== null">
    <div class="videos pos-video-wrapper desktop-frame-wrapper" *ngIf="!minimized">
      <div class="pos-connecting" *ngIf="!currentFrameSrc">
        <span>Waiting for desktop frames...</span>
      </div>

      <img
        #desktopFrame
        *ngIf="currentFrameSrc"
        [src]="currentFrameSrc"
        class="pos-video desktop-frame"
        tabindex="0"
        alt="Desktop View"
        (mousedown)="desktopFrameRef.nativeElement.focus(); onDesktopMouseEvent($event)"
        (mouseup)="onDesktopMouseEvent($event)"
        (mousemove)="onDesktopMouseEvent($event)"
        (dblclick)="onDesktopMouseEvent($event)"
        (wheel)="onDesktopWheelEvent($event)"
        (keydown)="onDesktopKeyEvent($event)"
        (keyup)="onDesktopKeyEvent($event)"
      />
    </div>

    <div class="controls" *ngIf="!minimized">
      <span class="desktop-resolution" *ngIf="posDesktopSession">
        {{ posDesktopSession.screenWidth }}×{{ posDesktopSession.screenHeight }}
      </span>
      <button nbButton size="tiny" status="danger" (click)="endDesktopSession()">
        End Desktop
      </button>
    </div>
  </ng-container>
</div>
